import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";

export const LastName = ({
  value,
  isErrored,
  onChange,
  intl,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps) => {
  const isFieldHidden = getFieldConfigByFieldId("lastName")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="lastName"
      autoComplete="family-name"
      value={value}
      onChange={onChange}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({ id: "lastNamePlaceholder", defaultMessage: "Last Name" })
      }
      label={<FormattedHTMLMessage id="lastName" defaultMessage="Last name" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidLastName" defaultMessage="Invalid last name" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      disabled={disabled}
    />
  );
};
export const LastNameComponent = injectIntl(LastName);
